import { dismissToast, toasts } from '../state/toast'
import { useStore } from '../state/store'
import './toast.css'

export function ToastHost() {
  const toast = useStore(toasts)
  return (
    <div className="toast-host" aria-live="polite">
      {toast && (
        <div key={toast.id} className="toast" data-tone={toast.tone} role="status">
          <span className="toast-message">{toast.message}</span>
          {toast.action && (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                toast.action?.run()
                dismissToast(toast.id)
              }}
            >
              {toast.action.label}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
